var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 25C0.5 11.4686 11.4686 0.5 25 0.5C38.5314 0.5 49.5 11.4686 49.5 25C49.5 38.5314 38.5314 49.5 25 49.5C11.4686 49.5 0.5 38.5314 0.5 25Z",
    fill: "#23262F",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.542 36.5534L37.9174 16.1851C38.3042 14.3917 37.2611 13.6859 36.0712 14.1283L10.3447 23.9148C8.58655 24.589 8.61857 25.5608 10.0486 26.0006L16.6276 28.0284L31.9039 18.5343C32.6189 18.0629 33.2752 18.3289 32.739 18.8003L20.384 29.8219L19.9064 36.5244C20.5894 36.5244 20.8909 36.2321 21.2457 35.8766L24.4605 32.819L31.1303 37.6674C32.3521 38.3416 33.2139 37.9914 33.542 36.5508V36.5534Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 24,
    fill: "white",
    transform: "translate(9 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramlogo);
export default __webpack_public_path__ + "static/media/telegramlogo.475b40fff648255138e488eee0b1f2d2.svg";
export { ForwardRef as ReactComponent };